@let filteredGroupData = filteredGroupData$ | async;

<ng-container *transloco="let t">
    @if (hasSearch()) {
        <div
            sticky
            stickyTop="-8"
            stickyStart="0"
            class="bh-padding-bottom-4x"
            style="background: var(--bazis-background)"
        >
            <bazis-input-default
                style="--bazis-margin-6x: 0"
                [formControl]="search"
                rightIcon="search"
                [hasEraser]="true"
                [placeholder]="searchPlaceholder()"
            ></bazis-input-default>
        </div>
    }

    @if (filteredGroupData?.length) {
        @switch (mode()) {
            @case ('full') {
                @for (item of filteredGroupData; track $index) {
                    <div
                        class="bazis-percentage-block"
                        [class.bazis-percentage-block--active]="selectedValues()?.includes(item.id)"
                        (click)="select.emit(item.id)"
                    >
                        <div class="bh-flex bh-justify-content-between bh-margin-bottom-1x">
                            <span class="bazis-percentage-block__count">{{
                                item.value | localNumber: '1.0-3'
                            }}</span>
                            <span class="bazis-percentage-block__percent bazis-h6 bh-no-margin">
                                {{ item.fraction | localNumber: '1.0-2' }}%
                            </span>
                        </div>
                        <div class="bh-ellipsis">
                            {{ item.name || t('analytics.groups.emptyName') }}
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="bar"
                            [ngTemplateOutletContext]="{
                                fraction: item.fraction,
                            }"
                        ></ng-container>
                    </div>
                }
            }

            @case ('short') {
                @for (item of filteredGroupData; track $index; let first = $first) {
                    <div
                        class="bazis-percentage-block"
                        [class.bazis-percentage-block--active]="selectedValues()?.includes(item.id)"
                        (click)="select.emit(item.id)"
                        #refTooltip
                    >
                        <div class="bh-flex bh-justify-content-between">
                            <span class="bh-ellipsis">
                                {{ item.name || t('analytics.groups.emptyName') }}
                            </span>
                            <span>{{ item.value | localNumber: '1.0-3' }}</span>
                        </div>
                        <ng-container
                            [ngTemplateOutlet]="bar"
                            [ngTemplateOutletContext]="{
                                fraction: item.fraction,
                            }"
                        ></ng-container>

                        @if (item.name) {
                            <bazis-tooltip
                                [reference]="refTooltip"
                                [placement]="first ? 'bottom' : 'top'"
                                [arrow]="false"
                                [isStatic]="true"
                                [offset]="[0, -12]"
                            >
                                {{ item.name }}
                            </bazis-tooltip>
                        }
                    </div>
                }
            }
        }
    } @else {
        <div> {{ t('analytics.groups.empty') }}</div>
    }

    <ng-template
        #bar
        let-fraction="fraction"
    >
        <div class="bazis-percentage-bar_mini">
            <div
                class="bazis-percentage-bar__part"
                [class.bazis-percentage-bar__part_full]="fraction === 1"
                color="action"
                [style.width]="fraction + '%'"
                [style.--min-width]="fraction ? '1px' : '0'"
            ></div>
        </div>
    </ng-template>
</ng-container>
